import { addActionBarItem, PageLocationId } from "@bb-vendure/admin-ui/core";
import { marker as _ } from "@biesbjerg/ngx-translate-extract-marker";
import { ModalService } from "@bb-vendure/admin-ui/core";
import { GuidanceComponent } from "./guidance-component/guidance.component";
import guidanceList from "./component-list";
import { Provider } from "@angular/core";
import { take } from "rxjs";

function addActionBarItemByList(): Provider[] {
  return guidanceList.map((locationId) => {
    return addActionBarItem({
      id: `guidance-button-${locationId}`,
      label: _("common.guidance"),
      locationId: locationId as PageLocationId,
      onClick: async (event, context) => {
        context.dataService.client
          .uiState()
          .mapStream(({ uiState }) => uiState.contentLanguage)
          .pipe(take(1))
          .subscribe((language) => {
            const modalService = context.injector.get(ModalService);
            modalService
              .fromComponent(GuidanceComponent, {
                locals: {
                  language: language,
                  locationId: locationId,
                },
                closable: true,
                size: 'xl',
              })
              .subscribe((result) => {
                console.log(result);
              });
          });
      },
    });
  });
}

export default [...addActionBarItemByList()];
